import React from "react";

export default function Synonims(props) {
  if (props.synonims) {
    console.log(props.synonims);
    return (
      <div className="synonims">
        {props.synonims.map(function (synonim, index) {
          return <li key={index}>{synonim}</li>;
        })}
      </div>
    );
  } else {
    return null;
  }
}
